export default class DefaultPaymentGateway {
    // #region Vars
    _initialized = false;
    _api = {};
    _configuration = {};
    // #endregion
    // #region Properties
    get isInitialized() {
        return this._initialized;
    }
    get api() {
        return this._api;
    }
    get isTestMode() {
        return this._configuration?.isTestMode ?? false;
    }
    // #endregion
    // #region Boostrap
    async initialize(configuration) {
        // #region Init
        if (!this._initialized) {
            this._configuration = configuration;
            this._initialized = true;
        }
        // #endregion
        return true;
    }
    // #endregion
    // #region Core
    async createElement(name, methodConfiguration) {
        return {};
    }
    async handle(command, args) {
        // #region Url
        if (command === 'redirect_to_url') {
            //Url
            window.location.href = args.nextActionUrl;
            //Result
            return {
                isSucceeded: true
            };
        }
        // #endregion
        // #region Fallback
        else {
            return {
                isSucceeded: true
            };
        }
        // #endregion
    }
}
